export const SET_STATE = 'checkoutPage/vehicleRental/SET_STATE';
export const SET_FETCHING = 'checkoutPage/vehicleRental/SET_FETCHING';
export const SET_VEHICLE_RENTALS = 'checkoutPage/vehicleRental/SET_VEHICLE_RENTALS';
export const SET_FILTERED_VEHICLES = 'checkoutPage/vehicleRental/SET_FILTERED_VEHICLES';
export const SET_DRIVERS_DATES_OF_BIRTH = 'checkoutPage/vehicleRental/SET_DRIVERS_DATES_OF_BIRTH';
export const SET_CURRENT_REQUEST_PARAMETERS = 'checkoutPage/vehicleRental/SET_CURRENT_REQUEST_PARAMETERS';
export const RESET_STATE = 'checkoutPage/vehicleRental/RESET_STATE';
